import {IconButton, Snackbar as RawSnackbar, styled} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Snackbar = ({
    open,
    onClose,
    message,
    errorText,
    autoHideDuration = 3000,
}) => {
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }

        onClose()
    }

    const snackbarText = errorText ?? message

    return (
        <StyledSnackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            message={snackbarText}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        />
    )
}

export default Snackbar

const StyledSnackbar = styled(RawSnackbar)`
    & .MuiPaper-root {
        display: flex;
        justify-content: space-between;
    }
    & .MuiPaper-root .MuiSnackbarContent-action {
        margin: 0;
        margin-left: 0;
        padding-left: 0;
    }
`
